var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hashtag",class:[_vm.clickable ? 'clickable' : '', _vm.isActive ? 'active' : ''],on:{"click":_vm.handleClick}},[_c('span',[_vm._v("#"+_vm._s(_vm.slug))])])}
var staticRenderFns = []

export { render, staticRenderFns }